import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { openWidget } from '../../actions/app-state';
import { readCoupon, closeMessage } from '../../actions/bookboost/proactive-message-actions';
import * as tracker from '../../actions/bookboost/tracker';
import { COLORS } from '../../constants/styles';

ProactiveMessage.propTypes = {
    message: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    brandColor: PropTypes.string,
    isBrandColorDark: PropTypes.bool,
};

function ProactiveMessage({
    message: { id, title, content, button },
    dispatch,
    brandColor,
    isBrandColorDark,
}) {
    const createMarkup = (html) => {
        // TODO: Provide a safer way to do this!
        // See https://facebook.github.io/react/docs/dom-elements.html#dangerouslysetinnerhtml
        return { __html: html };
    };

    const buttonStyles = {
        backgroundColor: `#${brandColor}`,
        borderColor: `#${brandColor}`,
        color: isBrandColorDark ? COLORS.WHITE : COLORS.GRAY_SCARPA,
    };

    const stopPropagation = (e) => {
        e.stopPropagation();
    };

    const renderCouponButton = () => {
        const onCouponClick = (e) => {
            // TODO: Combine these two into a service?
            dispatch(readCoupon(id));
            dispatch(tracker.pmCouponClicked(id));
            e.preventDefault();
            e.stopPropagation();
        };
        const renderContent = () => {
            if (button.couponRead) {
                return (
                    <div>
                        <div className='bb-small'>Use this code:</div>
                        <div className='bb-code'>{ button.button_data }</div>
                    </div>
                );
            }
            return (
                <button
                    className='btn btn-bb-success bb-button'
                    type='button'
                    onClick={ onCouponClick }
                    style={ buttonStyles }>
                    { button.text }
                </button>
            );
        };
        return (
            <div className='bb-coupon-code-wrapper' onClick={ stopPropagation }>
                <div className='bb-coupon-code'>
                    { renderContent() }
                </div>
            </div>
        );
    };

    const renderLinkButton = () => (
        <a
            className='btn btn-bb-primary bb-button'
            href={ button.button_data }
            rel='noopener noreferrer'
            target='_blank'
            onClick={ stopPropagation }
            style={ buttonStyles }>
            { button.text }
        </a>
    );

    const renderButton = () => {
        switch (button.type) {
            case 'empty':
                return undefined;
            case 'coupon':
                return renderCouponButton();
            case 'link':
                return renderLinkButton();

            default:
                console.warn(`Button type ${button.type} not supported yet.`); break;
        }
    };

    const onProactiveMessageClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(openWidget());
        dispatch(tracker.pmClicked(id));
    };

    const onCloseButtonClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(closeMessage(id));
    };

    return (
        <div className='bb-proactive-message-wrapper'>
            <div className='bb-proactive-message' onClick={ onProactiveMessageClick }>
                <button type='button' className='bb-close-button' onClick={ onCloseButtonClick }>
                    <i className='fa fa-times' />
                </button>
                <div className='bb-header'>{ title }</div>
                <section className='bb-content' dangerouslySetInnerHTML={createMarkup(content)} />
                { renderButton() }
            </div>
        </div>
    );
}

export default connect(({config: {colors}}) => {
    return {
        brandColor: colors.brandColor,
        isBrandColorDark: colors.isBrandColorDark,
    };
})(ProactiveMessage);
